import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import Operations from '../../../operations'
import { HelpLink, SectionHeader, Spinner } from '../../../components/generic'
import { sizes } from '@lmc/common/constants'
import MemberBenefit from './MemberBenefit'

export const MemberBenefits = (props) => {
  const { refreshLists, memberBenefits } = props

  React.useEffect(() => {
    refreshLists()
    window.scrollTo(0, 0)
  }, [])

  return (
    <div style={styles.container}>
      <SectionHeader title={TITLE} />
      <p style={styles.subTitle}>{SUB_TITLE}</p>
      <div style={styles.content}>
        {memberBenefits ? (
          memberBenefits.map((benefit) => (
            <MemberBenefit key={benefit.id} benefit={benefit} />
          ))
        ) : (
          <Spinner />
        )}
      </div>
      <p>{FOOT_NOTE}</p>
      <div style={styles.helpLinkContainer}>
        <HelpLink supportLink={SUPPORT_LINK} />
      </div>
    </div>
  )
}

const TITLE = 'Perks'
const SUB_TITLE =
  'Who can pass up a good deal?! We’ve got loads of exclusive offers for Log my Care members from our amazing partners. From major discounts on technology to steals on training classes, get your mitts on these deals before they’re gone!'
const FOOT_NOTE =
  'All offers and discounts are at the discretion of the provider, terms and conditions may apply.'
const SUPPORT_LINK =
  'https://support.logmycare.co.uk/en/articles/4811119-community-perks'

MemberBenefits.propTypes = {
  memberBenefits: PropTypes.array,
}

const styles = {
  container: {
    margin: '0 auto',
    maxWidth: sizes.childScreen,
    padding: '24px 24px',
  },
  helpLinkContainer: {
    marginTop: 10,
  },
  subTitle: { paddingBottom: 12 },
  content: { minHeight: 300 },
}

const mapStateToProps = (state) => ({
  memberBenefits: state.data['member-benefits'],
})

const mapDispatchToProps = (dispatch) => ({
  refreshLists: () => dispatch(Operations.loadList('member-benefits')),
})

export default connect(mapStateToProps, mapDispatchToProps)(MemberBenefits)
